import { render } from "./GoRateAvatar.vue?vue&type=template&id=4c8d0323&ts=true"
import script from "./GoRateAvatar.vue?vue&type=script&lang=ts"
export * from "./GoRateAvatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__